import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {dayFromApi} from './reducer';

export const fetchEvents = (type, day, to, institutionId, childId, employeeId) =>
    RESTClient.getAuthenticatedObservable('v2/calendar', {
        type,
        day,
        to,
        institutionId,
        childId,
        employeeId,
    }).map(response =>
        List(response)
            .reduce((reduction, period) => reduction.concat(period.days), List())
            .map(day => dayFromApi(day, childId)),
    );

export const deleteAction = actionId => RESTClient.deleteAuthenticatedObservable(`v2/actions/${actionId}`);

export const deletePlannedCheckoutDate = (childId, planId, date) =>
    RESTClient.deleteAuthenticatedObservable(`v2/children/${childId}/plannedCheckout/${planId}/${date}`);

export const deletePlannedCheckout = (childId, planId) =>
    RESTClient.deleteAuthenticatedObservable(`v2/children/${childId}/plannedCheckout/${planId}`);

export const deleteSleep = napId =>
    RESTClient.deleteAuthenticatedObservable('daycare/sleep/delete', {
        napId,
    });

export const deleteCheckin = childCheckinId => {
    return RESTClient.deleteAuthenticatedObservable(`v2/childcheckins/${childCheckinId}`);
};

export const deleteStatus = statusId => RESTClient.deleteAuthenticatedObservable(`v2/status/registrations/${statusId}`);
